module.exports = __webpack_public_path__ + "img/stop.572acbf1.svg";